<script setup lang="ts">
import type { Component } from "vue";
import { computed } from "vue";

import { getPropertyConfig } from "~/common/properties";
import DropdownMenuItemContent from "~/components/dumb/DropdownMenuItemContent.vue";
import Template from "~/components/dumb/Template.vue";
import Tooltip from "~/components/dumb/Tooltip.vue";
import { PROPERTY_KIND_DESCRIPTIONS } from "~/constants/property";
import { Placement, PropertyKind } from "~/shared/enums";
import type { Property } from "~/shared/types";

const props = defineProps<{
  title: string;
  icon: Component;
  property?: Property;
  propertyKind: PropertyKind;
  showTooltipImage?: boolean;
}>();

const propertyKindDescription = computed(() => PROPERTY_KIND_DESCRIPTIONS.get(props.propertyKind));
const propertyConfig = computed(() => getPropertyConfig(props.propertyKind));

const text = computed(() => props.property?.description || propertyConfig.value?.description);
</script>

<template>
  <Tooltip
    v-if="propertyKindDescription && props.showTooltipImage"
    :placement="Placement.RIGHT"
    :image="propertyKindDescription.image"
    :image-text="propertyKindDescription.description"
    class="w-full">
    <DropdownMenuItemContent :title="title" :icon="icon" />
  </Tooltip>
  <component :is="text ? Tooltip : Template" v-else :placement="Placement.LEFT" :text="text" block height-block>
    <DropdownMenuItemContent :title="title" :icon="icon" />
  </component>
</template>
